import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

export default class EditProfileSuccess extends Component {

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  render () {
    const { query } = this.context.location;
    return (
      <div>
        <h1>Profile Updated!</h1>
        <Link to="/" query={query} className="btn btn-sm btn-primary">
          Return to Dashboard
        </Link>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/editProfileSuccess.jsx